<template>
  <div class="pg-input-number-max">
    <InputNumber
      class="pg-input-number-max-input"
      ref="PgInputNumber"
      :max="max"
      v-bind="$attrs"
      :value="valueData"
      v-on="event"
      @input="onInput"
    ></InputNumber>
    <span class="pg-input-number-max-max"
      >MAX: <span @click="onMaxClick">{{ max }}</span></span
    >
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { InputNumber } from 'element-ui'
import { useListeners, computed, ref } from 'vue'

const props = defineProps({
  value: Number,
  max: String,
})

const listeners = useListeners()
const event = computed(() =>
  Object.keys(listeners).reduce((pre, cur) => {
    if (cur !== 'input') pre[cur] = listeners[cur]
    return pre
  }, {})
)
const valueData = computed(() => {
  if (props.value === null) {
    return undefined
  } else {
    return props.value
  }
})

const emit = defineEmits('input', 'blur')
const onInput = (val) => {
  if (valueData.value !== val) {
    emit('input', val)
  }
}
const onMaxClick = () => {
  onInput(props.max)
}
const PgInputNumber = ref(null)

defineExpose({
  focus: () => {
    PgInputNumber.value.focus()
  },
})
</script>
<style lang="scss">
.pg-input-number-max {
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  .pg-input-number-max-max {
    font-size: 12px;
    color: #333333;
    .pg-input-number-max-input {
      width: 100%;
    }
    span {
      cursor: pointer;
      color: var(--color-warning);
    }
  }
}
</style>
